export default function permissoesUsuario(state = [], action) {
  // //
  // if (action.sessao) {
  //   //
  // }
  switch (action.type) {
    case 'LOGIN': {
      return [...state, action.sessao];
    }
    default:
      return state;
  }
}
